<template>
  <div class="country-form-field-item">
    <div class="tabs">
      <span :class="['currency-info', { active: active === 1 }]" @click="handleCurrencyInfo">通用信息</span>
      <span :class="['variant-info', { active: active === 2 }]" @click="handleVariantInfo">变体信息</span>
    </div>

    <div class="body-footer">
      <div class="body">
        <div v-show="active === 1" class="base-info-container">
          <card title="基础信息">
            <el-row>
              <el-col :span="2">
                <div class="label">SPU</div>
              </el-col>
              <el-col :span="8">
                <el-input disabled v-model="formSource.spuCode" size="medium" placeholder="请输入spu" />
              </el-col>
              <el-col :span="3">
                <div class="label" style="text-align:right;padding-right:10px">
                  <i style="color:red">*</i>
                  SEO标题
                </div>
              </el-col>
              <el-col :span="8">
                <el-input v-model="seo.seoTitle" size="medium" :maxlength="150" placeholder="请输入SEO标题" />
              </el-col>
              <el-col :span="2">
                <div class="label" style="padding-left:10px">{{ (seo.seoTitle  && seo.seoTitle.length) || 0 }}/150</div>
              </el-col>
            </el-row>
            <el-row class="el-row">
              <el-col :span="2">
                <div class="label">商品名称</div>
              </el-col>
              <el-col :span="8">
                <el-input disabled v-model="formSource.productName" size="medium" placeholder="请输入商品名称" />
              </el-col>
              <el-col :span="3">
                <div class="label" style="text-align:right;padding-right:10px">SEO描述</div>
              </el-col>
              <el-col :span="8">
                <el-input v-model="seo.seoDescription" size="medium" :maxlength="300" placeholder="请输入SEO描述" />
              </el-col>
              <el-col :span="2">
                <div class="label" style="padding-left:10px">{{ (seo.seoDescription && seo.seoDescription.length) || 0 }}/300</div>
              </el-col>
            </el-row>
            <el-row class="el-row">
              <el-col :span="2">
                <div class="label">品类</div>
              </el-col>
              <el-col :span="8">
                <el-cascader ref="cascader" disabled placeholder="请选择品类" v-model="categoryList[1].categoryId" :options="newCategoryOptions" size="medium" :props="{ value: 'categoryId', label: 'name', children: 'childList', emitPath: false }" filterable clearable class="el-width" @change="(e) => changeCascader(e, 2)">
                  <template slot-scope="{ node, data }">
                    <span>{{ data.name }}</span>
                    <span v-if="!node.isLeaf"> ({{ data.childList.length }}) </span>
                  </template>
                </el-cascader>
              </el-col>
              <el-col :span="3">
                <div class="label" style="text-align:right;padding-right:10px">SEO关键词</div>
              </el-col>
              <el-col :span="8">
                <el-input v-model="seo.seoKeyWords" size="medium" :maxlength="200" placeholder="请输入SEO关键词" />
              </el-col>
              <el-col :span="2">
                <div class="label" style="padding-left:10px">{{ (seo.seoKeyWords && seo.seoKeyWords.length) || 0 }}/200</div>
              </el-col>
            </el-row>

            <el-row>
              <el-col :span="2">
                <div class="label">商品分组</div>
              </el-col>
              <el-col :span="8">
                <el-select disabled size="medium" v-model="formSource.virtualWarehouseId" placeholder="请选择" class="el-width">
                  <el-option v-for="item in virtualWarehouse" :key="item.id" :label="item.virtualWarehouseName" :value="item.id" />
                </el-select>
              </el-col>
              
            </el-row>
            <el-row>
              <el-col :span="2">
                <div class="label" style="text-align:left;padding-right:10px"><i style="color:red">*</i> 网址</div>
              </el-col>
              <el-col :span="19">
                <div class="f--c">
                  <div style="flex-shrink: 0;">{{ kakaUrl }}</div>
                  <el-input disabled v-model.trim="seo.seoSearchTerm" size="medium" placeholder="请输入" @input="handleInput" />
                </div>
              </el-col>
              <el-col :span="2">
                <div class="label" style="padding-left:10px"><i class="pointer iconfont el-icon-document-copy" @click="handleCopy"></i></div>
              </el-col>
              
            </el-row>

            <el-row>
              <el-col :span="2">
                <span>描述</span>
              </el-col>
              <el-col :span="8" />
              <el-col :span="14" />
            </el-row>
            <el-row>
              <!-- <el-input size="medium" v-model="formSource.description" type="textarea" placeholder="请输入内容" maxlength="1000" show-word-limit :rows="5" /> -->
              <RichEditor disabled :value="formSource.description" @input="(data) => (formSource.description = data)" />
            </el-row>
          </card>

          <card title="其他参数">
            <el-row>
              <el-col :span="2">
                <div class="label">退换条款</div>
              </el-col>
              <el-col :span="8">
                <el-select disabled size="medium" v-model="formSource.policyId" placeholder="请选择" class="el-width">
                  <el-option v-for="item in clauseOptionss" :key="item.code" :label="item.name" :value="item.code" />
                </el-select>
              </el-col>
              <el-col :span="14" />
            </el-row>
          </card>

          <card title="尺码表">
            <el-upload disabled slot="custom" action="#" :show-file-list="false" :before-upload="beforeSizeImagePathUpload">
              <span>{{ formSource.sizeImagePath}}</span>
            </el-upload>
            <el-image v-if="formSource.sizeImagePath" fit="cover" :src="formSource.sizeImagePath" class="size-surface">
              <span slot="placeholder" class="image-slot">加载中...</span>
            </el-image>
            <div v-else class="size-surface" style="background-color: #f5f7fa;" />
          </card>

          <card title="图片" :marginBottom="0">
            <span v-if="fileList.length" slot="custom" class="confirm-upload" @click="confirmUpload">确认上传</span>
            <div class="image-preview-container">
      
              <!-- 新图片 -->
              <template v-if="fileList.length">
                <div v-for="(image, index) in fileList" :key="`${image.url},${index}`" class="image-preview-box add-image-preview-box">
                  <el-image fit="cover" :src="fileList[index].url" :preview-src-list="filterFileList" class="image-preview" lazy>
                    <span slot="placeholder" class="image-slot">加载中...</span>
                  </el-image>
                  <span class="el-icon-close-box" @click="() => deleteFileListImagePreview(image)">
                    <i class="el-icon-close" />
                  </span>
                </div>
              </template>
              <!-- 原始图片 -->
              <div v-for="(image, index) in formSource.imgUrl" :key="`${image},${index}`" class="image-preview-box">
                <el-image fit="cover" :src="formSource.imgUrl[index] | imgToWebp" :preview-src-list="formSource.imgUrl" class="image-preview" lazy>
                  <span slot="placeholder" class="image-slot">加载中...</span>
                </el-image>
              </div>
            </div>
          </card>
        </div>

        <div v-show="active === 2" class="variant-container">
          <!-- <div class="variant-height">
            <el-button :disabled="!selectionChangeCheckboxData.length" size="medium" type="primary" round @click="handleBatchSetUp">批量设置</el-button>
          </div> -->
          <div class="variant-body">
            <el-table :data="formSource.variableList" height="100%" class="el-table" @selection-change="selectionChangeCheckbox" row-key="id">
              <el-table-column type="selection" width="50" />
              <el-table-column prop="skuCode" label="SKU" align="center" fixed="left" width="260" />
              <el-table-column prop="option1.value" label="Color" align="center" fixed="left" width="150" />
              <el-table-column prop="option2.value" label="Size" align="center" width="150"/>
              <el-table-column prop="material" label="材质" align="center" show-overflow-tooltip width="220px"/>
              <el-table-column label="图片" align="center" width="80px">
                <template slot-scope="{ row }">
                  <img :src="isMain(row.imagesList)" class="image-row" alt="image" />
                </template>
              </el-table-column>
              <el-table-column prop="packageLength" label="长(cm)" align="center" width="100" />
              <el-table-column prop="packageWidth" label="宽(cm)" align="center" width="100" />
              <el-table-column prop="packageHeight" label="高(cm)" align="center" width="100" />
              <el-table-column prop="packageWeight" label="重量(g)" align="center" width="150" />
              <el-table-column prop="cost" label="成本(USD)" align="center" width="150" />
              <el-table-column prop="price" label="售价(USD)" align="center" width="150" />
              <el-table-column label="起订量" align="center" width="150">
                <template slot="header">
                  <quantityBatch @submit="orderQuantityBatchSubmit"></quantityBatch>
                </template>
                <template slot-scope="{ row }">
                  <el-input-number v-model="row.minOrderQuantity" @blur="setOrderQuantity(row.minOrderQuantity)" size="mini" controls-position="right" :min="0" :max="9999999" :class="{emptyInput: minOrderQuantityHaveEmpty && alreadyFillColors.includes(row.option1.value) && !row.minOrderQuantity}" />
                </template>
              </el-table-column>
              <el-table-column label="订金比例(%)" align="center" width="150">
                <template slot-scope="{ row }">
                  <el-input-number v-model="row.earnestMoneyRate" size="mini" controls-position="right" :precision="2" :max="100" />
                </template>
              </el-table-column>
              <el-table-column prop="stock" label="虚拟总库存" align="center" width="100" />
              <el-table-column label="实际总库存" align="center" width="150">
                <template slot-scope="{ row }">
                  <el-popover placement="button" width="380" trigger="click">
                    <el-table :data="row.stockList">
                      <el-table-column property="warehouseName" label="仓库" />
                      <el-table-column property="stock" label="实际总库存" width="100" />
                    </el-table>
                    <span slot="reference" style="color: #99c41c;cursor: pointer;">{{ row.realStock }}</span>
                  </el-popover>
                </template>
              </el-table-column>
              <el-table-column  label="产品状态" align="center" width="150">
                <template slot-scope="{ row }">
                  {{ row.status == 0 ? '下架' : row.status == 1 ? '在售' : '缺货'}}
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </div>

      <div class="footer">
        <el-button class="info-btn" type="info" round @click="handleCancel">取 消</el-button>
        <el-button :loading="confirmBtnLoading" class="primary-btn" type="primary" round @click="handleConfirm">确 定</el-button>
      </div>
    </div>

    <!-- 批量设置对话框 -->
    <el-dialog title="批量设置" border :visible.sync="batchSetUpDialogVisible" width="731px" :before-close="handleCloseBatchSetUpDialog" class="batch-set-up-dialog">
      <el-form ref="form" :model="batchSetUpForm" label-width="70px" label-position="left">
        <el-form-item label="Color">
          <el-input v-model="batchSetUpForm.option1" size="mini" :maxlength="50" />
        </el-form-item>
        <el-form-item label="Size">
          <el-input v-model="batchSetUpForm.option2" size="mini" :maxlength="50" />
        </el-form-item>
        <el-form-item label-width="155px">
          <template slot="label">
            <el-radio-group v-model="batchSetUpForm.isPriceOrProfitRadio">
              <el-radio :label="1">售价</el-radio>
              <el-radio :label="2">利润率</el-radio>
            </el-radio-group>
          </template>
          <el-input-number class="input-radio" v-model="batchSetUpForm.isPriceOrProfit" size="mini" controls-position="right" :precision="2" :max="9999999" />
          <span class="label-right">{{ batchSetUpForm.isPriceOrProfitRadio === 1 ? 'USD' : '%' }}</span>
        </el-form-item>
        <el-form-item label="起订量">
          <el-input-number style="width:89%;" v-model="batchSetUpForm.minOrderQuantity" size="mini" controls-position="right" :min="0" :max="9999999" />
          <span class="label-right">PCS</span>
        </el-form-item>
        <el-form-item label="订金比例">
          <el-input-number style="width:89%;" v-model="batchSetUpForm.earnestMoneyRate" size="mini" controls-position="right" :precision="2" :max="100" />
          <span class="label-right">%</span>
        </el-form-item>
        <el-form-item label="材质">
          <span class="material-text" @click="handleMaterial">{{ batchSetUpForm.material ? batchSetUpForm.material : '选择' }}</span>
        </el-form-item>
        <el-form-item label="包装尺寸">
          <span class="long-text">长</span>
          <el-input-number v-model="batchSetUpForm.packageLength" size="mini" controls-position="right" :precision="2" :max="1000" />
          <span class="long-cm">cm</span>
          <span class="wide-text">宽</span>
          <el-input-number v-model="batchSetUpForm.packageWidth" size="mini" controls-position="right" :precision="2" :max="1000" />
          <span class="wide-cm">cm</span>
          <span class="high-text">高</span>
          <el-input-number v-model="batchSetUpForm.packageHeight" size="mini" controls-position="right" :precision="2" :max="1000" />
          <span class="high-cm">cm</span>
        </el-form-item>
        <el-form-item label="重量">
          <el-input-number style="width:89%;" v-model="batchSetUpForm.packageWeight" size="mini" controls-position="right" :precision="2" :max="99999" />
          <span class="label-right">g</span>
        </el-form-item>
        <el-form-item label="图片">
          <span v-if="!batchSetUpForm.imagesList.length" class="imgs-text" @click="handleBatchSetUpFormImgs">图片</span>
          <template v-else>
            <div v-for="img in batchSetUpForm.imagesList" :key="img.imgUrl" class="el-image-imgs-box">
              <el-image :src="img.imgUrl" fit="cover" class="el-image-imgs" @click="handleBatchSetUpFormImgs" />
              <span v-if="isBatchSetUpFormImageMain(img)" class="image-main">主图</span>
            </div>
          </template>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button size="medium" @click="handleCloseBatchSetUpDialog">取 消</el-button>
        <el-button size="medium" type="primary" @click="handleDialogConfirmBatchSetUp">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 编辑材质对话框 -->
    <el-dialog title="编辑材质" border :visible.sync="materialDialogVisible" width="780px" :before-close="handleCloseMaterial">
      <div class="dialog-material">
        <div class="dialog-material-left">
          <div>
            <span class="add-material-text" @click="hanldeAddMaterial">添加</span>
          </div>
          <div class="dialog-material-left-main-container">
            <div v-for="material in editMaterialData" :key="material.key" class="dialog-material-left-main">
              <div class="dialog-material-left-main-label" :style="{ color: material.key === DialogMaterialLeftMainLabelKey ? '#99c41c' : '' }" :title="material.label" @click="() => handleDialogMaterialLeftMainLabel(material)">
                <span v-if="!material.isEditLabel" class="label-text">{{ material.label }}</span>
                <el-input v-else v-model="material.label" size="mini" />
              </div>
              <div class="dialog-material-left-main-operation">
                <span v-if="!material.isEditLabel" class="dialog-material-left-main-edit" @click="() => (material.isEditLabel = true)">编辑</span>
                <span v-else class="dialog-material-left-main-edit" @click="material.isEditLabel = false">确定</span>
                <span v-if="material.key !== 0" class="dialog-material-left-main-delete" @click="() => hanldeDeleteMaterial(material)">删除</span>
              </div>
            </div>
          </div>
        </div>
        <div class="dialog-material-right">
          <el-table :data="editMaterialDataTableData" height="353px">
            <el-table-column align="center" label="材质" prop="material">
              <template slot-scope="{ row }">
                <el-select v-model="row.material" filterable size="mini" placeholder="请选择">
                  <el-option v-for="item in materialSelectData" :key="item.material" :label="item.material" :value="item.material" />
                </el-select>
              </template>
            </el-table-column>
            <el-table-column align="center" label="比例(%)" prop="earnestMoneyRate">
              <template slot-scope="{ row }">
                <el-input-number v-model="row.earnestMoneyRate" size="mini" controls-position="right" :precision="2" :max="100" />
              </template>
            </el-table-column>
            <el-table-column align="center" width="50px">
              <template slot="header">
                <span class="table-header-add" @click="handleTableAddSelectData">添加</span>
              </template>
              <template slot-scope="scope">
                <span class="table-body-delete" @click="() => handleTableDeleteSelectData(scope)">删除</span>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
      <span slot="footer">
        <el-button size="medium" @click="handleCloseMaterial">取 消</el-button>
        <el-button size="medium" type="primary" @click="handleDialogConfirmMaterial">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 编辑图片对话框 -->
    <el-dialog title="选择图片" border :visible.sync="imgDialogVisible" width="580px" :before-close="handleCloseImg">
      <div v-if="formSource.imgUrl.length" class="dialog-image-container">
        <div v-for="image in formSource.imgUrl" :key="image" class="dialog-image">
          <div :class="['dialog-image-box', { 'select-border': checkIsSelect(image) }]">
            <el-image class="dialog-image-item" :src="formSource.prefix + image" fit="cover" @click="() => handleDialogImageItem(image)" />
            <span v-if="isDialogImageMain(image)" class="dialog-image-main">主图</span>
          </div>
          <span class="main-graph" @click="() => handleMainGraph(image)">设置主图</span>
        </div>
      </div>
      <el-empty v-else description="请先上传图片" style="padding: 0;" />
      <span slot="footer">
        <el-button size="medium" @click="handleCloseImg">取 消</el-button>
        <el-button size="medium" type="primary" @click="handleDialogConfirmImg">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import _ from 'lodash'
import API from '@/api'
import Card from './Card.vue'
import RichEditor from '@/views/operation/copywriting/components/RichEditor.vue'
import quantityBatch from './quantityBatch.vue'
import { copy } from '@/utils'

let batchSetUpForm = {
  option1: undefined, // Color
  option2: undefined, // Size
  isPriceOrProfitRadio: 1, // 标记当前选中的是售价还是利润率
  isPriceOrProfit: undefined, // 存储售价或利润率的值
  minOrderQuantity: 0, // 起订量
  earnestMoneyRate: undefined, // 订金比例
  material: undefined, // 材质
  packageLength: undefined, // 包装尺寸 - 长
  packageWidth: undefined, // 包装尺寸 - 宽
  packageHeight: undefined, // 包装尺寸 - 高
  packageWeight: undefined, // 重量
  imagesList: [] // 图片
}

export default {
  props: {
    formSource: {
      type: Object,
      default: () => {}
    },
    kakaUrl: {
      type: String,
      default: () => ''
    },
    firstCategory: {
      type: String,
      default: () => ''
    },
  },
  components: {
    card: Card,
    RichEditor,
    quantityBatch
  },
  filters: {
    imgToWebp(value) {
      return `${value}?x-oss-process=image/resize,w_98,h_98,m_fill/format,webp`
    }
  },
  computed: {
    filterFileList() {
      return this.fileList.map((item) => item.url)
    },
    isMain() {
      return (imagesList) => {
        if (!imagesList) return undefined
        if (!imagesList.length) return undefined
        return imagesList.filter((item) => item.status)[0] ? `${this.formSource.prefix || ''}${imagesList.filter((item) => item.status)[0].imgUrl}?x-oss-process=image/resize,w_38,h_38,m_fill/format,webp` : undefined
      }
    },
    checkIsSelect() {
      return (image) => {
        if (this.editRowImg) {
          return this.editRowImg.some((item) => item.imgUrl === image)
        }
      }
    },
    isDialogImageMain() {
      return (image) => {
        if (this.editRowImg) {
          return this.editRowImg.some((item) => item.status === 1 && item.imgUrl === image)
        }
      }
    },
    isBatchSetUpFormImageMain() {
      return (img) => {
        return img.status
      }
    }
  },
  data() {
    return {
      active: 1, // 1.通用信息 2.变体信息

      pullSpuDataLoadingBtn: false, // 同步ERP数据按钮的加载状态
      confirmBtnLoading: false, // 确定按钮的加载状态

      selectionChangeCheckboxData: [], // 当前表格复选框勾选的数据

      categoryOptions: [], // 品类下拉框数据源
      newCategoryOptions: [], // 品类下拉框数据源（新）

      virtualWarehouse: [], // 虚拟仓库

      clauseOptionss: [], // 退换条款下拉框数据源

      fileList: [], // 通用信息 - 新增的图片

      batchSetUpDialogVisible: false, // 控制批量设置对话框的显示与隐藏
      batchSetUpForm: _.cloneDeep(batchSetUpForm), // 批量设置对话框中表单数据

      materialDialogVisible: false, // 控制编辑表格材质字段的对话框的显示与隐藏
      editRow: {}, // 当前编辑的行
      editMaterialData: [], // 编辑材质对话框数据源
      DialogMaterialLeftMainLabelKey: 0, // 控制编辑材质对话框中左侧当前点击的label的文字颜色
      parameter: {
        pageSize: 1000, // 每页显示条数
        pageNumber: 1 // 当前页
      }, // 获取材质列表的请求参数
      materialSelectData: [], // 编辑材质对话框中表格材质字段中下拉框的数据源
      editMaterialDataTableData: [], // 编辑材质对话框中右侧表格当前点击的label项中的select数据源

      imgDialogVisible: false, // 控制编辑表格图片字段的对话框的显示与隐藏
      editRowImg: [], // 当前编辑的行中的图片数组 - 用于编辑图片

      categoryList: [
        { type: 1, categoryId: undefined, categoryName: undefined },
        { type: 2, categoryId: undefined, categoryName: undefined },
      ],
      alreadyFillColors: [],
      minOrderQuantityHaveEmpty: false,

      seo: {
        seoTitle: undefined,
        seoDescription: undefined,
        seoKeyWords: undefined,
        seoSearchTermPrefix: undefined,
        seoSearchTerm: undefined
      },
    }
  },
  created() {
    // this.getCategoryList(1)
    this.getCategoryList(2)
    this.getPublicSelectData()
    this.getVirtualWarehouseList()
    this.getMateriaByLanguageId(this.formSource.languageId)
    this.formSource.imgUrl = this.formSource.imgUrl.map(item => this.formSource.prefix + item)

    for(let key in this.seo) {
      if (key === 'seoSearchTerm') {
        this.seo[key] = this.formSource[key].split(this.firstCategory)[1]
      } else this.seo[key] = this.formSource[key]
    }
  },
  watch: {
    'formSource.languageId'(value) {
      this.getMateriaByLanguageId(value)
    }
  },
  mounted() {
    if (this.formSource.categoryList && this.formSource.categoryList.length) {
      let list = _.sortBy(this.formSource.categoryList, 'type')
      if (list.length > 1) this.categoryList = list
      else {
        let categoryList = list
        list[0].type === 1 ? categoryList.push({ type: 2, categoryId: undefined}) : categoryList.unshift({ type: 1, categoryId: undefined})
        this.categoryList = categoryList
      }
    }
  },
  methods: {
    changeCascader(value, type) {
      if (value) {
        this[type===1?'categoryOptions':'newCategoryOptions'].forEach((item) => {
          if (item.categoryId === value) {
            this.categoryList[type-1].categoryName = item.name
          }
        })
      } else {
        this.categoryList[type-1].categoryName = null
      }
    },

    // 获取虚拟仓库
    async getVirtualWarehouseList() {
      let { data } = await API.getVirtualWarehouseList()
      this.virtualWarehouse = data
    },

    // 获取品类列表
    async getCategoryList(type) {
      let { data } = await API.getCategoryList({ pageNumber: 1, pageSize: 1000, type })
      if (data && data.list.length) {
        this.deletechildList(data.list)
        if (type === 1) this.categoryOptions = data.list
        if (type === 2) this.newCategoryOptions = data.list
      }
    },
    deletechildList(arr) {
      // 删除最后一级为空的childList字段
      arr.forEach((item) => {
        if (!item.childList.length) {
          delete item.childList
        } else {
          this.deletechildList(item.childList)
        }
      })
    },

    // 根据语言ID获取材质下拉列表
    async getMateriaByLanguageId(value) {
      let { data } = await API.getMateriaByLanguageId(value)
      this.materialSelectData = data
    },

    // 获取退换条款下拉数据
    async getPublicSelectData() {
      let { data } = await API.getPublicSelectData({ type: 2, param: undefined })
      this.clauseOptionss = data
    },

    // 通用信息
    handleCurrencyInfo() {
      this.active = 1
    },

    // 变体信息
    handleVariantInfo() {
      this.active = 2
    },

    // 同步ERP数据
    async pullSpuData() {
      if (!this.formSource.spuCode) {
        this.$message.warning('请输入spu')
      } else {
        try {
          this.pullSpuDataLoadingBtn = true
          let result = await API.synchronizationERPData(this.formSource.spuCode)
          if (result.code !== 10000) {
            this.pullSpuDataLoadingBtn = false
            return this.$message.error(result.message)
          }
          result.data.variableList.forEach((item) => {
            if (item.option1 || item.option2 || item.option3) {
              item.option1 = item.option1 ? JSON.parse(item.option1) : undefined
              item.option2 = item.option2 ? JSON.parse(item.option2) : undefined
              item.option3 = item.option3 ? JSON.parse(item.option3) : undefined
            }
          })
          let kkProductId = this.formSource.kkProductId
          let languageId = this.formSource.languageId
          Object.assign(this.formSource, result.data)
          this.formSource.kkProductId = kkProductId
          this.formSource.languageId = languageId
          this.pullSpuDataLoadingBtn = false
        } catch (error) {
          this.pullSpuDataLoadingBtn = false
          throw new Error(error.message)
        }
      }
    },

    // 上传尺码表 - 上传文件之前的钩子
    beforeSizeImagePathUpload(file) {
      API.signValue({ directory: 'test/' }).then(({ data }) => {
        let formData = new FormData()
        formData.append('directory', 'test/')
        formData.append('signValue', data)
        formData.append('fileList', file)
        API.uploadFile(formData).then((result) => {
          if (result.code !== 10000) {
            return this.$message.error(result.message)
          }
          this.formSource.sizeImagePath = result.data
        })
      })
      return false
    },

    // 上传图片 - 确认上传
    confirmUpload() {
      API.signValue({ directory: 'test/' }).then(({ data }) => {
        let formData = new FormData()
        formData.append('directory', 'test/')
        formData.append('signValue', data)
        this.fileList.forEach((file) => {
          formData.append('fileList', file.raw)
        })
        API.uploadFile(formData).then(({ data }) => {
          data = data.split(',')
          this.formSource.imgUrl = [...data, ...this.formSource.imgUrl]
          this.fileList = []
          this.$refs.imgUrlUpload.clearFiles()
        })
      })
    },

    // 上传图片 - 文件状态改变时的钩子
    onChangeImgUrl(file, fileList) {
      let existFile = fileList.slice(0, fileList.length - 1).find((f) => f.name === file.name)
      if (existFile) {
        fileList.pop()
      } else {
        this.fileList = fileList
      }
    },

    // 通用信息 - 图片字段的删除新增图片
    deleteFileListImagePreview(image) {
      this.fileList = this.fileList.filter((file) => file.url !== image.url)
    },

    // 通用信息 - 图片字段的删除图片
    deleteImagePreview(image) {
      this.formSource.imgUrl = this.formSource.imgUrl.filter((item) => item !== image)
    },

    // 批量设置
    handleBatchSetUp() {
      this.batchSetUpDialogVisible = true
    },

    // 当表格复选框选择项发生变化时会触发该事件
    selectionChangeCheckbox(selection) {
      this.selectionChangeCheckboxData = selection
    },

    // 点击当前行材质字段触发的事件
    handleMaterial(row) {
      let disassembleMaterial = undefined
      // 如果是批量设置中调用
      if (this.batchSetUpDialogVisible) {
        disassembleMaterial = this.batchSetUpForm.material
      } else {
        // 如果是列表中的材质字段调用
        this.editRow = row
        disassembleMaterial = row.material
      }
      this.materialDialogVisible = true
      if (!disassembleMaterial) {
        this.editMaterialData.push({
          key: 0,
          isEditLabel: false,
          select: []
        })
      } else {
        disassembleMaterial.split(';').forEach((item, index) => {
          if (item) {
            if (item.split(':').length === 1) {
              this.editMaterialData.push({
                key: index,
                label: undefined,
                isEditLabel: false,
                select: item
                  .split(':')[0]
                  .split(',')
                  .map((selectItem) => ({ key: index, material: selectItem.split(' ')[1], earnestMoneyRate: selectItem.split(' ')[0].split('%')[0] }))
              })
            } else {
              this.editMaterialData.push({
                key: index,
                label: item.split(':')[0],
                isEditLabel: false,
                select: item
                  .split(':')[1]
                  .split(',')
                  .map((selectItem) => ({ key: index, material: selectItem.split(' ')[1], earnestMoneyRate: selectItem.split(' ')[0].split('%')[0] }))
              })
            }
          }
        })
        this.editMaterialDataTableData = this.editMaterialData[0].select
      }
    },

    // 点击当前行图片字段触发的事件
    handleImageRow(row) {
      this.editRow = row
      this.editRowImg = _.cloneDeep(row.imagesList)
      this.imgDialogVisible = true
    },

    // 表格售价字段数字输入框发生改变时的事件
    changePrice(currentValue, oldValue, row) {
      // 利润率 = 售价 / 成本 - 1
      row.profitRate = currentValue / row.cost - 1
    },

    // 表格利润率字段数字输入框发生改变时的事件
    changeProfit(currentValue, oldValue, row) {
      // 售价 = 成本 *（1 + 利润率）
      row.price = row.cost * (1 + currentValue)
    },

    // 表格上架状态开关发生变化时的回调
    changeSwitch(value, row) {
      if (!row.option1.value) {
        // Color
        this.$message.warning('请填写颜色Color')
      } else if (!row.option2.value) {
        // Size
        this.$message.warning('请填写尺码Size')
      } else if (!row.imagesList.length) {
        // 图片
        this.$message.warning('请先维护图片信息')
      } else if (!row.packageLength) {
        // 尺寸-长
        this.$message.warning('请填写尺寸长度')
      } else if (!row.packageWidth) {
        // 尺寸-宽
        this.$message.warning('请填写尺寸宽度')
      } else if (!row.packageHeight) {
        // 尺寸-高
        this.$message.warning('请填写尺寸高度')
      } else if (!row.packageWeight) {
        // 重量
        this.$message.warning('请填写重量')
      } else if (!row.price) {
        // 售价
        this.$message.warning('请填写售价')
      } else if (!row.cost) {
        // 成本
        this.$message.warning('请填写成本')
      } else {
        row.status = value
        row.isChange = !row.isChange
      }
    },

    // 批量设置对话框图片字段文字或已选中图片的点击事件
    handleBatchSetUpFormImgs() {
      this.editRowImg = _.cloneDeep(this.batchSetUpForm.imagesList)
      this.imgDialogVisible = true
    },

    // 批量设置对话框的关闭事件
    handleCloseBatchSetUpDialog() {
      this.batchSetUpForm = _.cloneDeep(batchSetUpForm)
      this.batchSetUpDialogVisible = false
    },

    // 批量设置对话框的确认事件
    handleDialogConfirmBatchSetUp() {
      this.selectionChangeCheckboxData.forEach((item) => {
        this.batchSetUpForm.option1 && (item.option1.value = this.batchSetUpForm.option1)
        this.batchSetUpForm.option2 && (item.option2.value = this.batchSetUpForm.option2)
        this.batchSetUpForm.minOrderQuantity && (item.minOrderQuantity = this.batchSetUpForm.minOrderQuantity)
        this.batchSetUpForm.earnestMoneyRate && (item.earnestMoneyRate = this.batchSetUpForm.earnestMoneyRate)
        this.batchSetUpForm.material && (item.material = this.batchSetUpForm.material)
        this.batchSetUpForm.packageLength && (item.packageLength = this.batchSetUpForm.packageLength)
        this.batchSetUpForm.packageWidth && (item.packageWidth = this.batchSetUpForm.packageWidth)
        this.batchSetUpForm.packageHeight && (item.packageHeight = this.batchSetUpForm.packageHeight)
        this.batchSetUpForm.packageWeight && (item.packageWeight = this.batchSetUpForm.packageWeight)
        this.batchSetUpForm.imagesList.length && (item.imagesList = this.batchSetUpForm.imagesList)
        if (this.batchSetUpForm.isPriceOrProfit) {
          if (this.batchSetUpForm.isPriceOrProfitRadio === 1) {
            // 售价
            item.price = this.batchSetUpForm.isPriceOrProfit
            item.profitRate = item.price / item.cost - 1
          } else if (this.batchSetUpForm.isPriceOrProfitRadio === 2) {
            // 利润率
            item.profitRate = this.batchSetUpForm.isPriceOrProfit
            item.price = item.cost * (1 + item.profitRate)
          }
        }
      })
      this.handleCloseBatchSetUpDialog()
    },

    // 编辑表格材质字段的对话框中左侧添加按钮的点击事件
    hanldeAddMaterial() {
      this.editMaterialData.push({
        key: this.editMaterialData.length,
        label: undefined,
        isEditLabel: false,
        select: []
      })
    },

    // 编辑表格材质字段的对话框中左侧删除按钮的点击事件
    hanldeDeleteMaterial(material) {
      this.editMaterialData = this.editMaterialData.filter((item) => item.key !== material.key)
      this.editMaterialDataTableData = []
      this.DialogMaterialLeftMainLabelKey = undefined
    },

    // 编辑表格材质字段的对话框中左侧label字段的点击事件
    handleDialogMaterialLeftMainLabel(material) {
      if (material.key === this.DialogMaterialLeftMainLabelKey) return
      this.DialogMaterialLeftMainLabelKey = material.key
      this.editMaterialDataTableData = material.select
    },

    // 编辑表格材质字段的对话框中右侧添加的点击事件
    handleTableAddSelectData() {
      this.editMaterialData.forEach((item) => {
        if (item.key === this.DialogMaterialLeftMainLabelKey) {
          this.$set(item, 'select', [...item.select, { key: this.editMaterialDataTableData.length, material: undefined, earnestMoneyRate: 0 }])
          this.editMaterialDataTableData = item.select
        }
      })
    },

    // 编辑表格材质字段的对话框中右侧删除按钮的点击事件
    handleTableDeleteSelectData(scope) {
      this.editMaterialDataTableData.splice(scope.$index, 1)
    },

    // 编辑表格材质字段的对话框关闭事件
    handleCloseMaterial() {
      // 如果是列表中的材质字段调用
      if (!this.batchSetUpDialogVisible) {
        this.editRow = {}
      }
      this.editMaterialData = []
      this.materialDialogVisible = false
      this.editMaterialDataTableData = []
      this.DialogMaterialLeftMainLabelKey = 0
    },

    // 编辑表格材质字段的对话框确认事件
    handleDialogConfirmMaterial() {
      let flag = false
      this.editMaterialData.forEach((material) => {
        let sum = 0
        material.select.forEach((item) => {
          sum += item.earnestMoneyRate
        })
        if (sum === 100) {
          flag = true
        } else {
          flag = false
          return
        }
      })
      let materialFlag = false
      this.editMaterialData.forEach((material) => {
        material.select.forEach((item) => {
          if (!item.material) {
            materialFlag = false
          } else {
            materialFlag = true
          }
        })
      })
      if (!flag) {
        return this.$message.warning('单个备注所有材质的比例加起来需等于100')
      }
      if (!materialFlag) {
        return this.$message.warning('请选择材质')
      }
      // 做数据的组装
      let arr = []
      this.editMaterialData.forEach((item) => {
        let strArr = []
        if (item.label) {
          strArr.push(item.label)
          strArr.push(`${item.select.map((selectItem) => `${selectItem.earnestMoneyRate}% ${selectItem.material}`).join(',')}`)
          arr.push(`${strArr.join(':')};`)
        } else {
          strArr.push(`${item.select.map((selectItem) => `${selectItem.earnestMoneyRate}% ${selectItem.material}`).join(',')}`)
          arr.push(strArr)
        }
      })
      // 如果是批量设置中调用
      if (this.batchSetUpDialogVisible) {
        this.batchSetUpForm.material = arr.join('')
      } else {
        // 如果是列表中的材质字段调用
        this.editRow.material = arr.join('')
      }
      this.handleCloseMaterial()
    },

    // 编辑表格图片字段的对话框 - 点击图片事件
    handleDialogImageItem(image) {
      if (this.checkImgIsExistence(image)) {
        this.editRowImg = this.editRowImg.filter((item) => item.imgUrl !== image)
      } else {
        this.editRowImg.push({
          imgUrl: image,
          status: 0
        })
      }
    },
    checkImgIsExistence(image) {
      // 检查当前的图片是否已存在
      if (!image) return false
      return this.editRowImg.some((item) => item.imgUrl === image)
    },

    // 编辑表格图片字段的对话框 - 设置主图
    handleMainGraph(image) {
      this.editRowImg.forEach((item) => (item.status = 0))
      if (this.checkImgIsExistence(image)) {
        this.editRowImg.forEach((item) => {
          if (item.imgUrl === image) {
            item.status = 1
          }
        })
      } else {
        this.editRowImg.push({
          imgUrl: image,
          status: 1
        })
      }
    },


    // 起订量失去焦点事件
    setOrderQuantity(e) {
      if(e == undefined) {
        this.formSource.variableList.forEach(item => {
          if(item.minOrderQuantity == undefined) item.minOrderQuantity = 0
        })
      }
    },
  

    // 编辑表格图片字段的对话框关闭事件
    handleCloseImg() {
      if (!this.batchSetUpDialogVisible) {
        this.editRow = {}
      }
      this.editRowImg = []
      this.imgDialogVisible = false
    },

    // 编辑表格材质图片的对话框确认事件
    handleDialogConfirmImg() {
      if (this.batchSetUpDialogVisible) {
        // 设置给批量设置对话框中的图片字段的
        this.batchSetUpForm.imagesList = _.cloneDeep(this.editRowImg)
      } else {
        // 设置给表格中的图片字段的
        this.editRow.imagesList = _.cloneDeep(this.editRowImg)
      }
      this.handleCloseImg()
    },

    // 取消
    handleCancel() {
      this.$router.push('/supply/goods')
    },

    // 确定
    async handleConfirm() {
      this.formSource.categoryList = this.categoryList.filter(item => item.categoryId)
      let newFormSource = _.cloneDeep(this.formSource)
      for (let key in this.seo) {
        if (key === 'seoSearchTerm') {
          newFormSource.seoSearchTerm = `${this.firstCategory}${this.seo.seoSearchTerm}`
        } else newFormSource[key] = this.seo[key]
      }
      if (!newFormSource.seoTitle) {
        return this.$message.warning('请输入SEO标题')
      }
      if (!newFormSource.seoSearchTerm || !this.seo.seoSearchTerm) {
        return this.$message.warning('请输入网址')
      }
      this.confirmBtnLoading = true
      newFormSource.variableList.forEach((item) => {
        item.option1 = JSON.stringify(item.option1)
        item.option2 = JSON.stringify(item.option2)
        item.option3 = JSON.stringify(item.option3)
      })
      // 校验是否sku填了起订量，相同颜色不同尺码未填
      this.alreadyFillColors = newFormSource.variableList.filter(e=>e.minOrderQuantity).map(e=>JSON.parse(e.option1).value)
      const isCheck = this.alreadyFillColors.every(color=>{
        return newFormSource.variableList.every(e=>{
          if(JSON.parse(e.option1).value === color) return !!e.minOrderQuantity
          return true
        })
      })
      if(!isCheck) {
        this.minOrderQuantityHaveEmpty = true
        this.confirmBtnLoading = false
        return
      }
      this.minOrderQuantityHaveEmpty = false
      if (this.$route.params.id) {
        // 编辑
        let result = await API.confirmEditProduct(newFormSource)
        if (result.code === 10000) {
          this.$message.success(result.message)
        } else {
          this.$message.error(result.message)
        }
        this.confirmBtnLoading = false
      } else {
        // 新增
        let result = await API.addProduct(newFormSource)
        if (result.code === 10000) {
          this.$message.success(result.message)
        } else {
          this.$message.error(result.message)
        }
        this.confirmBtnLoading = false
      }
    },
    orderQuantityBatchSubmit(value) {
      this.formSource.variableList.forEach(e=>e.minOrderQuantity = value)
    },
    handleInput() {
      let value = this.seo.seoSearchTerm
      value = value.replace(/[^\w'-\s&]/ig,'')
      this.seo.seoSearchTerm = value
    },
    handleCopy() {
      copy(this.kakaUrl+this.seo.seoSearchTerm)
    },
  }
}
</script>

<style lang="scss" scoped>
.country-form-field-item {
  height: calc(100% - 35px);

  .tabs {
    padding-bottom: 5px;
    .currency-info,
    .variant-info {
      display: inline-block;
      color: #cdd4dd;
      padding: 4px 52px;
      background-color: #fff;
      user-select: none;
      cursor: pointer;
      border-top-left-radius: 8px;
      border-top-right-radius: 8px;
      transition: background-color 0.3s;
    }

    .active {
      color: #fff;
      background-color: #99c41c;
      transition: all 0.3s;
    }

    .currency-info {
      margin-right: 8px;
    }
  }

  .body-footer {
    min-width: 1000px;
    display: flex;
    flex-direction: column;
    height: 100%;
    .body {
      flex: 1;
      height: calc(100% - 58px - 5px);
      .base-info-container {
        height: 100%;
        overflow-y: scroll;
      }
      .label {
        line-height: 36px;
      }
      .pull-spu-btn {
        margin-left: 15px;
      }
      .el-row {
        margin: 10px 0;
      }
      .el-width {
        width: 100%;
      }
      .size-surface {
        position: relative;
        width: 300px;
        height: 300px;
        overflow: hidden;
        border-radius: 4px;
        vertical-align: middle;
      }
      .image-slot {
        position: absolute;
        top: 50%;
        left: 50%;
        color: #99c41c;
        font-size: 12px;
        transform: translate(-50%, -50%);
      }
      .confirm-upload {
        user-select: none;
        cursor: pointer;
      }
      .image-preview-container {
        display: flex;
        flex-wrap: wrap;
        .el-upload {
          color: #8c939d;
          width: 100px;
          height: 100px;
          text-align: center;
          line-height: 100px;
          margin-right: 15px;
          border-radius: 4px;
          overflow: hidden;
          vertical-align: middle;
          border: 1px dashed #d9d9d9;
          .uploader-icon {
            font-size: 16px;
            color: #8c939d;
            width: 100px;
            height: 100px;
            line-height: 100px;
            text-align: center;
          }
          &:hover {
            border-color: #99c41c;
            .uploader-icon {
              color: #99c41c;
            }
          }
        }
        .image-preview-box {
          position: relative;
          display: inline-block;
          height: 100px;
          width: 100px;
          margin-right: 15px;
          margin-bottom: 15px;
          border: 1px solid #dcdfe6;
          border-radius: 4px;
          .image-preview {
            position: relative;
            width: 100%;
            height: 100%;
            border-radius: 4px;
            vertical-align: middle;
          }
          &:last-child {
            margin-left: 0;
          }
          .el-icon-close-box {
            position: absolute;
            top: -6px;
            right: -6px;
            color: #fff;
            height: 16px;
            width: 16px;
            font-size: 14px;
            text-align: center;
            line-height: 16px;
            background-color: #dcdfe6;
            border-radius: 50%;
            user-select: none;
            cursor: pointer;
            &:hover {
              color: #f56c6c;
            }
          }
        }
        .add-image-preview-box {
          border: 1px dashed #f56c6c;
        }
      }

      .variant-container {
        height: 100%;
        width: 100%;
        padding: 15px;
        background-color: #fff;
        .variant-height {
          margin-bottom: 15px;
        }
        .variant-body {
          width: 100%;
          height: calc(100% - 32px);
          background-color: pink;
          .el-table {
            width: 100%;
          }
          .el-input-number-box {
            display: flex;
            justify-content: space-between;
            .el-input-number {
              width: 108px;
            }
          }
          .material-row {
            color: #99c41c;
            user-select: none;
            cursor: pointer;
          }
          .image-row {
            width: 38px;
            height: 38px;
            vertical-align: middle;
            object-fit: cover;
            border-radius: 4px;
            cursor: pointer;
          }
          .emptyInput{
            /deep/.el-input__inner{
              border-color: red;
            }
          }
        }
      }
    }

    .footer {
      height: 58px;
      line-height: 58px;
      text-align: center;
      margin-top: 5px;
      background-color: #fff;
      .info-btn,
      .primary-btn {
        padding: 8px 32px;
      }
      .primary-btn {
        margin-left: 52px;
      }
    }
  }
}

.dialog-material {
  display: flex;
  height: 380px;
  border-radius: 4px;
  border: 1px solid #ccc;
  .dialog-material-left {
    flex: 5;
    border-right: 1px solid #ccc;
    overflow: hidden;
    .add-material-text {
      display: inline-block;
      color: #99c41c;
      font-size: 14px;
      padding: 12px;
      user-select: none;
      cursor: pointer;
    }
    .dialog-material-left-main-container {
      height: calc(100% - 44px);
      overflow: auto;
      padding: 0 12px 12px;
      .dialog-material-left-main {
        display: flex;
        height: 28px;
        margin-top: 12px;
        &:first-child {
          margin-top: 0;
        }
        .dialog-material-left-main-label {
          flex: 1;
          margin-right: 12px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          user-select: none;
          cursor: pointer;
          .label-text {
            line-height: 28px;
          }
          &:hover {
            color: #99c41c;
          }
        }
        .dialog-material-left-main-operation {
          display: flex;
          width: 65px;
          justify-content: space-between;
          text-align: center;
          line-height: 28px;
          .dialog-material-left-main-edit,
          .dialog-material-left-main-delete {
            color: #99c41c;
            font-size: 14px;
            user-select: none;
            cursor: pointer;
          }
        }
      }
    }
  }
  .dialog-material-right {
    flex: 7;
    padding: 12px;
    .table-header-add,
    .table-body-delete {
      color: #99c41c;
      user-select: none;
      cursor: pointer;
    }
  }
}

.dialog-image-container {
  max-height: 580px;
  overflow: auto;
  .dialog-image {
    display: inline-block;
    width: 70px;
    height: 98px;
    text-align: center;
    overflow: hidden;
    margin-right: 15px;
    &:last-child {
      margin-right: 0;
    }
    .dialog-image-box {
      position: relative;
      overflow: hidden;
      border: 2px solid #cdd4dd;
      border-radius: 4px;
      .dialog-image-item {
        width: 100%;
        height: 68px;
        vertical-align: middle;
        user-select: none;
        cursor: pointer;
      }
      .dialog-image-main {
        position: absolute;
        left: 0;
        bottom: 0;
        color: #fff;
        font-size: 12px;
        width: 100%;
        opacity: 0.8;
        user-select: none;
        background-color: #f1a0aa;
      }
    }
    .select-border {
      border: 2px solid #99c41c !important;
    }
    .main-graph {
      color: #99c41c;
      font-size: 12px;
      line-height: 28px;
      user-select: none;
      cursor: pointer;
    }
  }
}

.batch-set-up-dialog {
  .el-form-item {
    margin-bottom: 0;
    .el-input {
      width: 89%;
    }
    .el-radio {
      margin-right: 12px;
    }
    .input-radio {
      width: 87%;
    }
    .long-text,
    .high-text,
    .wide-text {
      margin-right: 6px;
    }
    .long-cm,
    .high-cm,
    .wide-cm {
      margin-left: 6px;
    }
    .label-right,
    .wide-text {
      margin-left: 12px;
    }
    .wide-cm {
      margin-right: 12px;
    }
    .material-text,
    .imgs-text {
      color: #99c41c;
      user-select: none;
      cursor: pointer;
    }
    .el-image-imgs-box {
      position: relative;
      display: inline-block;
      width: 68px;
      height: 68px;
      border: 1px solid #ccc;
      margin-top: 8px;
      margin-right: 12px;
      border-radius: 4px;
      overflow: hidden;
      cursor: pointer;
    }
    .el-image-imgs {
      width: 100%;
      height: 100%;
    }
    .image-main {
      position: absolute;
      left: 0;
      bottom: 0;
      color: #fff;
      font-size: 12px;
      width: 100%;
      text-align: center;
      line-height: 17px;
      opacity: 0.8;
      user-select: none;
      background-color: #f1a0aa;
    }
  }
}
</style>
